module.exports = __webpack_public_path__ + "media/images/j-09438e0975e18d5fb72b71d3d6d810ef.png";